// dependencies
import React from "react";

// components
import Logo from "assets/img/logo";

// styles
import css from "./PageSpinner.styl";

const PageSpinner = () => (
	<div className={css.main}>
		<div className={css.logoWrapper}>
			<Logo width={60} height={60} />
		</div>
	</div>
);

export default PageSpinner;
